import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCheck = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M9.68988 17.12C9.77988 17.23 9.91988 17.29 10.0599 17.29V17.27H10.0699C10.2199 17.27 10.3599 17.2 10.4499 17.09L18.2499 7.51998C18.4299 7.30998 18.3899 6.98998 18.1799 6.81998C17.9699 6.63998 17.6499 6.66998 17.4799 6.88998L10.0499 16.01L6.52988 12.04C6.33988 11.83 6.02988 11.82 5.81988 12C5.61988 12.19 5.59988 12.5 5.77988 12.71L9.68988 17.12Z' />
  </svg>
);
export default SvgCheck;
